import { useState } from 'react';

import './App.css';
import Slideshow from './components/slideshow.js';

function App() {
    const [bgColor, setBgColor] = useState("#ffe8bb");

    return (
        <div className="App">
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    overflow: "clip",
                    backgroundColor: bgColor,
                    zIndex: -1,
                }}/>
            <Slideshow setBgColor={setBgColor} />
        </div>
    );
}

export default App;
